/* course-product.js — accordion + session variant switcher */

(function () {
  'use strict';

  // ── Accordion ─────────────────────────────────────────────
  document.querySelectorAll('.cp-accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panel    = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  });

  // ── Tabs ──────────────────────────────────────────────────
  document.querySelectorAll('[data-cp-tabs]').forEach(function (widget) {
    var tabs   = Array.from(widget.querySelectorAll('.cp-tabs__tab'));
    var panels = Array.from(widget.querySelectorAll('.cp-tabs__panel'));

    function activate(tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      panels.forEach(function (p) { p.hidden = true; });
      tab.setAttribute('aria-selected', 'true');
      var panel = widget.querySelector('#' + tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab); });
    });

    if (tabs.length > 0) activate(tabs[0]);
  });

  // ── Mobile sidebar reorder ────────────────────────────────
  // Move the sidebar to sit directly after Course Overview on mobile
  function reorderSidebar() {
    var sidebar  = document.querySelector('.course-product__sidebar');
    var overview = document.querySelector('.course-product__main .cp-section');
    var layout   = document.querySelector('.course-product__layout');
    if (!sidebar || !overview || !layout) return;

    if (window.innerWidth < 1000) {
      // Insert sidebar immediately after the first cp-section (Course Overview)
      overview.after(sidebar);
    } else {
      // Restore sidebar as last child of layout (desktop position)
      layout.appendChild(sidebar);
    }
  }

  reorderSidebar();
  window.addEventListener('resize', reorderSidebar);

  // ── Variant price switcher ─────────────────────────────────
  var dataEl = document.getElementById('cp-variant-data');
  if (!dataEl) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variantMap = {};
  variants.forEach(function (v) { variantMap[v.id] = v; });

  var priceEl = document.getElementById('cp-price');
  var bookBtn = document.getElementById('cp-book-btn');

  function updateSidebar(variantId) {
    var v = variantMap[variantId];
    if (!v) return;
    if (priceEl) priceEl.textContent = v.priceFormatted;
    if (bookBtn) bookBtn.disabled = !v.available;
  }

  document.querySelectorAll('.cp-session-card__input').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.checked) updateSidebar(Number(input.value));
    });
    if (input.checked) updateSidebar(Number(input.value));
  });

  // ── Past date greying ─────────────────────────────────────
  function parseSessionDate(str) {
    return new Date(str.replace(/(\d+)(st|nd|rd|th)\b/i, '$1'));
  }

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  document.querySelectorAll('.cp-session-card').forEach(function (card) {
    var dateEl   = card.querySelector('.cp-session-card__date');
    var input    = card.querySelector('.cp-session-card__input');
    var spacesEl = card.querySelector('.cp-session-card__spaces');
    if (!dateEl || !input) return;

    var d = parseSessionDate(dateEl.textContent.trim());
    if (!isNaN(d) && d < today) {
      card.classList.add('cp-session-card--sold-out');
      input.disabled = true;
      if (spacesEl) spacesEl.textContent = 'Date passed';
    }
  });

  // If the pre-selected card is now past, move selection to first future date
  var checkedInput = document.querySelector('.cp-session-card__input:checked');
  if (!checkedInput || checkedInput.disabled) {
    var firstFuture = document.querySelector('.cp-session-card:not(.cp-session-card--sold-out) .cp-session-card__input:not(:disabled)');
    if (firstFuture) {
      firstFuture.checked = true;
      updateSidebar(Number(firstFuture.value));
    }
  }

  // ── Gallery lightbox ─────────────────────────────────────
  var gallery = document.querySelector('[data-cp-gallery]');
  if (gallery) {
    var lightbox = document.getElementById('cp-lightbox');
    var lbImg    = document.getElementById('cp-lb-img');
    var lbClose  = document.getElementById('cp-lb-close');
    var lbPrev   = document.getElementById('cp-lb-prev');
    var lbNext   = document.getElementById('cp-lb-next');
    var items    = Array.from(gallery.querySelectorAll('[data-cp-gallery-item]'));
    var current  = 0;

    function showImage(index) {
      current = index;
      var item  = items[index];
      lbImg.src = item.getAttribute('data-full');
      lbImg.alt = item.querySelector('img').alt;
      lbPrev.hidden = items.length <= 1;
      lbNext.hidden = items.length <= 1;
    }

    function openLightbox(index) {
      showImage(index);
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      lbImg.src = '';
    }

    items.forEach(function (item, i) {
      item.addEventListener('click', function () { openLightbox(i); });
    });

    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    lbPrev.addEventListener('click', function () {
      showImage((current - 1 + items.length) % items.length);
    });

    lbNext.addEventListener('click', function () {
      showImage((current + 1) % items.length);
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape')       closeLightbox();
      if (e.key === 'ArrowLeft')    showImage((current - 1 + items.length) % items.length);
      if (e.key === 'ArrowRight')   showImage((current + 1) % items.length);
    });
  }

}());
